import React from 'react'

import { UserFilter } from '../TableHeader/FilterTypes'
import HoverTooltip from '../../../../../../components/HoverTooltip'

type Props = {
    role: string // Роль
    stage: string // Стадия
    isSelect: boolean // Выбрана
    isChernovik: boolean // Черновик
    isReady: boolean // Готово
    isCanMoveBackToEdit: boolean // Подготовка к размещению - Готово
    isCanMoveReadyToEis: boolean // Подготовка к размещению - Подготовка
    isSendPlan: boolean // Отправлен план
    isUpdatingFromEis: boolean // Обновление из ЕИС
    isAnnulate: boolean // Аннулирование
    multiSelect: boolean
    planVersionDiff: boolean
    filter: UserFilter | null
    theme: string
    actions: Actions // Функции кнопок
    // status: string
    // multiSelect: boolean
}

// Функции кнопок
type Actions = {
    add: () => void // Создать
    ready_to_sent: () => void // Направить на подготовку к размещению
    return_to_edit: () => void // Вернуть на редактирование
    ready_to_eis: () => void // Подготовить к отправке в ЕИС
    ready_to_go_eis: () => void // Изменение статуса на Готово к отправке
    return_to_ready: () => void // Вернуть на подготовку к отправке в ЕИС
    sent_to_eis: () => void // Отправить в ЕИС
    update: () => void // Обновить из ЕИС
    export_plan: () => void // Скачать план
    export_plan_excel: () => void // Скачать план в Excel для отправки в ЕИС
    copy: () => void // Копировать из размещенной позиции
    copy_draft: () => void // Копировать из драфта
    delete: () => void // Удалить (относится только к драфтам)
    import_from_file: () => void // Загрузить из файла Excel
    print: () => void // Печать
    change: () => void // Изменения
    annulate: () => void // Аннулирование
    filter: () => void // Фильтр
}

type ButtonConfig = {
    id: string
    label: string
    onClick: () => void
    visibleCondition: boolean // Функция, проверяющая видимость
    className?: string // Стили для кнопки
    iconPathD: string
    iconFill: string
    disabled: boolean
    isLoading: boolean
}

const TableStageToolbarButtons: React.FC<Props> = ({
    role,
    stage,
    isSelect,
    isChernovik,
    isReady,
    isCanMoveBackToEdit,
    isCanMoveReadyToEis,
    isSendPlan,
    isUpdatingFromEis,
    isAnnulate,
    multiSelect,
    planVersionDiff,
    filter,
    theme,
    actions,
    // status,
    // multiSelect,
}) => {
    const isAdmin = role === 'admin'
    const isSpecialist = role === 'specialist'
    const isCurator = role === 'curator'
    const isInitiator = role === 'initiator'

    const isEditStage = stage === 'Редактирование'
    const isRaedyStage = stage === 'Подготовка к размещению'
    const isSentToEisStage = stage === 'Отправка в ЕИС'
    const isPurchasePlanStage = stage === 'План закупки в ЕИС'

    const isFilter = filter?.filter_settings?.filter_enabled || false

    // const isEditStatus = status === 'Черновик'
    // const isReadyStatus = status === 'Готово'
    // const isStandStatus = status === 'Подготовка'
    // const isReadyToEisStatus = status === 'Готово к отправке'
    // const isSentToEisStatus = status === 'Отправлено в ЕИС'
    // const isPublishedStatus = status === 'Размещена'

    const buttons: ButtonConfig[] = [
        {
            id: 'add',
            label: 'Создать',
            onClick: actions.add,
            visibleCondition: isEditStage || isPurchasePlanStage,
            className:
                'w-6 h-6 grid rounded-full place-items-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]',
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'ready_to_sent',
            label: 'Направить на подготовку к размещению',
            onClick: actions.ready_to_sent,
            visibleCondition:
                (isAdmin || isSpecialist || isCurator) && isEditStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${
                isSelect && isChernovik
                    ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]'
                    : ''
            }`,
            iconFill: `${isSelect && isChernovik ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !isSelect || !isChernovik,
            isLoading: false,
        },
        {
            id: 'return_to_edit',
            label: 'Вернуть',
            onClick: actions.return_to_edit,
            visibleCondition: (isAdmin || isSpecialist) && isRaedyStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && isCanMoveBackToEdit ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect && isCanMoveBackToEdit ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M21,11H9.41l2.3-2.29a1,1,0,1,0-1.42-1.42l-4,4a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l4,4a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H21a1,1,0,0,0,0-2ZM3,3A1,1,0,0,0,2,4V20a1,1,0,0,0,2,0V4A1,1,0,0,0,3,3Z',
            disabled: !isSelect || !isCanMoveBackToEdit,
            isLoading: false,
        },
        {
            id: 'ready_to_eis',
            label: 'Подготовить к отправке в ЕИС',
            onClick: actions.ready_to_eis,
            visibleCondition: (isAdmin || isSpecialist) && isRaedyStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && isCanMoveReadyToEis && !isSendPlan ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect && isCanMoveReadyToEis && !isSendPlan ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !isSelect || !isCanMoveReadyToEis || isSendPlan,
            isLoading: false,
        },
        {
            id: 'return_to_ready',
            label: 'Вернуть',
            onClick: actions.return_to_ready,
            visibleCondition: (isAdmin || isSpecialist) && isSentToEisStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && !isSendPlan ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect && !isSendPlan ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M21,11H9.41l2.3-2.29a1,1,0,1,0-1.42-1.42l-4,4a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l4,4a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H21a1,1,0,0,0,0-2ZM3,3A1,1,0,0,0,2,4V20a1,1,0,0,0,2,0V4A1,1,0,0,0,3,3Z',
            disabled: !isSelect || isSendPlan,
            isLoading: false,
        },
        {
            id: 'sent_to_eis',
            label: 'Отправить в ЕИС',
            onClick: actions.sent_to_eis,
            visibleCondition: (isAdmin || isSpecialist) && isSentToEisStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${!isSendPlan && !planVersionDiff ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${!isSendPlan && !planVersionDiff ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M20.34,9.32l-14-7a3,3,0,0,0-4.08,3.9l2.4,5.37h0a1.06,1.06,0,0,1,0,.82l-2.4,5.37A3,3,0,0,0,5,22a3.14,3.14,0,0,0,1.35-.32l14-7a3,3,0,0,0,0-5.36Zm-.89,3.57-14,7a1,1,0,0,1-1.35-1.3l2.39-5.37A2,2,0,0,0,6.57,13h6.89a1,1,0,0,0,0-2H6.57a2,2,0,0,0-.08-.22L4.1,5.41a1,1,0,0,1,1.35-1.3l14,7a1,1,0,0,1,0,1.78Z',
            disabled: isSendPlan || planVersionDiff,
            isLoading: false,
        },
        {
            id: 'update',
            label: 'Обновить план из ЕИС',
            onClick: actions.update,
            visibleCondition: (isAdmin || isSpecialist) && isPurchasePlanStage,
            className: `w-6 h-6 grid rounded-full place-items-center  hover:bg-[#FFFFFF] dark:hover:bg-[#656365]`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M19.91,15.51H15.38a1,1,0,0,0,0,2h2.4A8,8,0,0,1,4,12a1,1,0,0,0-2,0,10,10,0,0,0,16.88,7.23V21a1,1,0,0,0,2,0V16.5A1,1,0,0,0,19.91,15.51ZM12,2A10,10,0,0,0,5.12,4.77V3a1,1,0,0,0-2,0V7.5a1,1,0,0,0,1,1h4.5a1,1,0,0,0,0-2H6.22A8,8,0,0,1,20,12a1,1,0,0,0,2,0A10,10,0,0,0,12,2Z',
            disabled: false,
            isLoading: isUpdatingFromEis,
        },
        {
            id: 'copy',
            label: 'Копировать',
            onClick: actions.copy,
            visibleCondition: isPurchasePlanStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M21,8.94a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19.32.32,0,0,0-.09,0A.88.88,0,0,0,14.05,2H10A3,3,0,0,0,7,5V6H6A3,3,0,0,0,3,9V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V18h1a3,3,0,0,0,3-3V9S21,9,21,8.94ZM15,5.41,17.59,8H16a1,1,0,0,1-1-1ZM15,19a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V9A1,1,0,0,1,6,8H7v7a3,3,0,0,0,3,3h5Zm4-4a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V5a1,1,0,0,1,1-1h3V7a3,3,0,0,0,3,3h3Z',
            disabled: !isSelect,
            isLoading: false,
        },
        {
            id: 'copy_draft',
            label: 'Копировать',
            onClick: actions.copy_draft,
            visibleCondition: !isPurchasePlanStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M21,8.94a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19.32.32,0,0,0-.09,0A.88.88,0,0,0,14.05,2H10A3,3,0,0,0,7,5V6H6A3,3,0,0,0,3,9V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V18h1a3,3,0,0,0,3-3V9S21,9,21,8.94ZM15,5.41,17.59,8H16a1,1,0,0,1-1-1ZM15,19a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V9A1,1,0,0,1,6,8H7v7a3,3,0,0,0,3,3h5Zm4-4a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V5a1,1,0,0,1,1-1h3V7a3,3,0,0,0,3,3h3Z',
            disabled: !isSelect,
            isLoading: false,
        },
        {
            id: 'change',
            label: 'Изменить',
            onClick: actions.change,
            visibleCondition: isPurchasePlanStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && multiSelect && isAnnulate ? 'text-[#FFFFFF] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : 'text-[#8A8A8A]'}`,
            iconFill: `${isSelect && multiSelect && isAnnulate ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M21,12a1,1,0,0,0-1,1v6a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4h6a1,1,0,0,0,0-2H5A3,3,0,0,0,2,5V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V13A1,1,0,0,0,21,12ZM6,12.76V17a1,1,0,0,0,1,1h4.24a1,1,0,0,0,.71-.29l6.92-6.93h0L21.71,8a1,1,0,0,0,0-1.42L17.47,2.29a1,1,0,0,0-1.42,0L13.23,5.12h0L6.29,12.05A1,1,0,0,0,6,12.76ZM16.76,4.41l2.83,2.83L18.17,8.66,15.34,5.83ZM8,13.17l5.93-5.93,2.83,2.83L10.83,16H8Z',
            disabled: !multiSelect || !isAnnulate,
            isLoading: false,
        },
        {
            id: 'annulate',
            label: 'Аннулировать',
            onClick: actions.annulate,
            visibleCondition: isPurchasePlanStage && (isSpecialist || isAdmin),
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && isAnnulate ? 'hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]' : ''}`,
            iconFill: `${isSelect && isAnnulate ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M15.71,8.29a1,1,0,0,0-1.42,0L12,10.59,9.71,8.29A1,1,0,0,0,8.29,9.71L10.59,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l2.3-2.29A1,1,0,0,0,15.71,8.29ZM19,2H5A3,3,0,0,0,2,5V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z',
            disabled: !isSelect || !isAnnulate,
            isLoading: false,
        },
        {
            id: 'export_plan',
            label: 'Скачать план',
            onClick: actions.export_plan,
            visibleCondition: (isAdmin || isSpecialist) && isPurchasePlanStage,
            className: `w-6 h-6 grid rounded-full place-items-center  hover:bg-[#FFFFFF] dark:hover:bg-[#656365]`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M8.29,13.29a1,1,0,0,0,0,1.42l3,3a1,1,0,0,0,1.42,0l3-3a1,1,0,0,0-1.42-1.42L13,14.59V3a1,1,0,0,0-2,0V14.59l-1.29-1.3A1,1,0,0,0,8.29,13.29ZM18,9H16a1,1,0,0,0,0,2h2a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H8A1,1,0,0,0,8,9H6a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V12A3,3,0,0,0,18,9Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'export_plan_excel',
            label: 'Скачать проект плана',
            onClick: actions.export_plan_excel,
            visibleCondition: (isAdmin || isSpecialist) && isSentToEisStage,
            className: `w-6 h-6 grid rounded-full place-items-center  hover:bg-[#FFFFFF] dark:hover:bg-[#656365]`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M8.29,13.29a1,1,0,0,0,0,1.42l3,3a1,1,0,0,0,1.42,0l3-3a1,1,0,0,0-1.42-1.42L13,14.59V3a1,1,0,0,0-2,0V14.59l-1.29-1.3A1,1,0,0,0,8.29,13.29ZM18,9H16a1,1,0,0,0,0,2h2a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H8A1,1,0,0,0,8,9H6a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V12A3,3,0,0,0,18,9Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'delete',
            label: 'Удалить',
            onClick: actions.delete,
            visibleCondition: isEditStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && isReady ? 'hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]' : ''}`,
            iconFill: `${isSelect && isReady ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z',
            disabled: !isSelect || !isReady,
            isLoading: false,
        },
        {
            id: 'import_from_file',
            label: 'Загрузить из файла Excel',
            onClick: actions.import_from_file,
            visibleCondition: isEditStage,
            className:
                'w-6 h-6 grid rounded-full place-items-center  hover:bg-[#FFFFFF] dark:hover:bg-[#656365]',
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M8.71,7.71,11,5.41V15a1,1,0,0,0,2,0V5.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42l-4-4a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-4,4A1,1,0,1,0,8.71,7.71ZM21,14a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V15a1,1,0,0,0-2,0v4a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V15A1,1,0,0,0,21,14Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'print',
            label: 'Печать',
            onClick: actions.print,
            visibleCondition: true,
            className:
                'w-6 h-6 grid rounded-full place-items-center  hover:bg-[#FFFFFF] dark:hover:bg-[#656365]',
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD:
                'M7,10a1,1,0,1,0,1,1A1,1,0,0,0,7,10ZM19,6H18V3a1,1,0,0,0-1-1H7A1,1,0,0,0,6,3V6H5A3,3,0,0,0,2,9v6a3,3,0,0,0,3,3H6v3a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V18h1a3,3,0,0,0,3-3V9A3,3,0,0,0,19,6ZM8,4h8V6H8Zm8,16H8V16h8Zm4-5a1,1,0,0,1-1,1H18V15a1,1,0,0,0-1-1H7a1,1,0,0,0-1,1v1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8H19a1,1,0,0,1,1,1Z',
            disabled: false,
            isLoading: false,
        },
        {
            id: 'filter',
            label: `${isFilter ? 'Отключить фильтр' : 'Фильтр'}`,
            onClick: actions.filter,
            visibleCondition: true,
            className: `w-6 h-6 grid rounded-full place-items-center  hover:bg-[#FFFFFF] dark:hover:bg-[#656365]`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD: `${
                isFilter
                    ? 'M19.22,6H12.66a1,1,0,0,0,0,2h6.56a.78.78,0,0,1,.78.78v.78H16.22a1,1,0,1,0,0,2h2.37l-.7.69a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l1.88-1.88a2.51,2.51,0,0,0,.54-.8h0l0-.1A2.59,2.59,0,0,0,22,9.82v-1A2.79,2.79,0,0,0,19.22,6ZM3.71,2.29A1,1,0,0,0,2.29,3.71L5.14,6.55A2.73,2.73,0,0,0,4,8.78v1a2.65,2.65,0,0,0,.24,1.1l0,.06a2.61,2.61,0,0,0,.54.81l5.41,5.4V21a1,1,0,0,0,.47.85,1,1,0,0,0,.53.15,1,1,0,0,0,.45-.11l3.56-1.78a1,1,0,0,0,.55-.89v-2h0l4.51,4.52a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42ZM6,8.78a.76.76,0,0,1,.5-.72L6.59,8,8.15,9.56H6Zm8.07,7.29a1,1,0,0,0-.29.71V18.6l-1.56.78v-2.6a1,1,0,0,0-.29-.71L7.41,11.56h2.74l4.22,4.22Z'
                    : 'M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z'
            }`,
            disabled: false,
            isLoading: false,
        },
    ]

    return (
        <>
            {buttons
                .filter((button) => button.visibleCondition) // Оставляем только видимые кнопки
                .map((button, index) => (
                    <button
                        key={index}
                        className={button.className}
                        onClick={button.onClick}
                        disabled={button.disabled}
                    >
                        {button.isLoading ? (
                            <HoverTooltip tooltipText={button.label}>
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            </HoverTooltip>
                        ) : (
                            <HoverTooltip tooltipText={button.label}>
                                <svg
                                    className="w-4 h-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id={button.id}
                                >
                                    <path
                                        fill={button.iconFill}
                                        d={button.iconPathD}
                                    ></path>
                                </svg>
                            </HoverTooltip>
                        )}
                    </button>
                ))}
        </>
    )
}

export default TableStageToolbarButtons
